module.exports = __webpack_public_path__ + "static/media/talent-background.0b688fc1.png";